import { ReactElement } from "react";
import Highlighter from "react-highlight-words";

import { useAuditLogContext } from "@ryde/redux";

interface ISearchHighlightProps {
  text: string;
  className?: string;
  /** Marks the key search instead of the value search. */
  isKey?: boolean;
}

/** Text of an audit row with the drawer's current search marked. */
export const SearchHighlight = ({
  text,
  className,
  isKey,
}: ISearchHighlightProps): ReactElement => {
  const { searchValue, keySearchValue } = useAuditLogContext();

  return (
    <Highlighter
      className={className}
      searchWords={[isKey ? (keySearchValue ?? "") : searchValue]}
      autoEscape={true}
      textToHighlight={text}
      highlightClassName="search-highlight"
    />
  );
};
